import { useSyncExternalStore } from 'react';

/**
 * Un solo timer per tutta l'app: ogni lista che mostra "5 min fa" si ridisegna al
 * cambio del minuto senza creare un setInterval per riga.
 */
let now = Date.now();
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(cb: () => void) {
  listeners.add(cb);
  if (!timer) {
    timer = setInterval(() => {
      now = Date.now();
      listeners.forEach((l) => l());
    }, 30 * 1000);
  }
  return () => {
    listeners.delete(cb);
    if (listeners.size === 0 && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
}

export function useMinuteTick(): number {
  return useSyncExternalStore(subscribe, () => now, () => now);
}
